import {
	GET_FILTERS_ORGANIZATION_CHART,
	GET_FILTERS_ORGANIZATION_CHART_ERROR,
	GET_FILTERS_ORGANIZATION_CHART_SUCCESS,
} from '../../constants';

export const getFiltersOrganizationChartRed = (state, actions) => {
	switch (actions.type) {
		case GET_FILTERS_ORGANIZATION_CHART:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
				isLoad: false,
			};
		case GET_FILTERS_ORGANIZATION_CHART_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
				isLoad: false,
			};
		case GET_FILTERS_ORGANIZATION_CHART_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				isLoad: true,
				data: actions.payload,
			};
		default:
			return state;
	}
};
